import { useContext } from "react"
import { WorkTask, WorkTaskProviderContext } from ".."

const MISSING_PROVIDER_MSG = "Missing WorkTaskProvider"
const EMPTY_PROMISE = () => Promise.reject(MISSING_PROVIDER_MSG)
const EMPTY_FUNCTION = () => undefined

const MOCKED_WORKTASK_PARAMS: WorkTask = {
    attachToWorkTask: EMPTY_PROMISE,
    createWorkTask: EMPTY_PROMISE,
    injectVehicleHistory: EMPTY_FUNCTION,
    openWorkTask: EMPTY_FUNCTION,
    reloadWorkTask: EMPTY_PROMISE,
    triggerWorkTaskConflict: EMPTY_FUNCTION,
    newWorkTaskLoading: false,
    workTaskLoading: false,
}

export function useWorkTask(): WorkTask {
    const workTaskParams = useContext(WorkTaskProviderContext)
    return workTaskParams ?? MOCKED_WORKTASK_PARAMS
}
